import { Culture } from '../../types';

export const carrier: Culture = {
  name: 'Carrier',
  languageFamily: 'Athabaskan',
  terms: [
    {
      word: 'Nadleh',
      phonetic: 'nahd-leh',
      description: 'Word meaning "river" in Carrier.'
    },
    {
      word: 'Sba',
      phonetic: 's-bah',
      description: 'Carrier term for "dog."'
    },
    {
      word: 'Ts’uhoh',
      phonetic: 'tsoo-hoh',
      description: 'Carrier word meaning "tree."'
    },
    {
      word: 'Uza',
      phonetic: 'oo-zah',
      description: 'Carrier word for "sun."'
    },
    {
      word: 'Wai',
      phonetic: 'why',
      description: 'Carrier greeting meaning "hello."'
    }
  ]
};